import React, { useEffect, useRef, useState } from "react";
import { Alert, Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, MenuItem, Select, SelectChangeEvent, Snackbar, SnackbarCloseReason, TextField } from "@mui/material";
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { propertieImages, SelectProperty } from "../../Services/Properties";
import { GenerateCaptionsServ, ListingVideoServ } from "../../Services/Video";
import { GetAccount } from "../../Services/Account";
import UploadImages from "../Comp-enhance-AIlisting/upload-images";
import { GetCompanyProfile } from "../../Services/Profile";
import { VideoObj } from "../../Models/Video";
import RecentVideos from "./recent-videos";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store/store";
import { fetchHeaderData } from "../store/headerSlice";
import { useTranslation } from "react-i18next";


const ListingVideo: React.FunctionComponent<{}> = (props) => {

    const [properties, setProperties] = useState<any>("");
    const [selectProperty, setSelectProperty] = useState<any>("");
    const [loading, setLoading] = useState(false);
    const [listImages, setListImages] = useState<any>();
    const [isSpinner, setIsSpinner] = useState<boolean>(false);
    const [isSpinnert, setIsSpinnert] = useState<boolean>(false);
    const [selectAll, setSelectAll] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const [selectMusic, setSelectMusic] = useState<any>("");
    const [showMsgUpgrade, setShowMsgUpgrade] = useState<any>("");
    const [language, setLanguage] = useState<any>();
    const [otherDesc, setOtherDesc] = useState<any>();
    const [videoValue, setVideoValue] = useState<VideoObj>()
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [colorSnackbar, setColorSnackbar] = useState<any>("");
    const [message, setMessage] = useState<string>();
    const [isUpload, setIsUpload] = useState<boolean>(false);
    const [isChange, setIsChange] = useState<boolean>(false);
    const [listAudios, setListAudios] = useState<any>([
        {
            "name": "Funk Fusion 1",
            "url": "https://www.api-v1.coralytics.com/api/audios/FunkFusion.mp3"
        },
        {
            "name": "Funk Fusion 2",
            "url": "https://www.api-v1.coralytics.com/api/audios/FunkFusion%202.mp3"
        },
        {
            "name": "Elegance Unfolding 1",
            "url": "https://www.api-v1.coralytics.com/api/audios/EleganceUnfolding%20(1).mp3"
        },
        {
            "name": "Elegance Unfolding 2",
            "url": "https://www.api-v1.coralytics.com/api/audios/EleganceUnfolding.mp3"
        },
        {
            "name": "Luxury Showcase 1",
            "url": "https://www.api-v1.coralytics.com/api/audios/LuxuryShowcase.mp3"
        }, {
            "name": "Luxury Showcase 2",
            "url": "https://www.api-v1.coralytics.com/api/audios/LuxuryShowcase%20(1).mp3"
        }
    ])
    const [isUpgradeMsg, setIsUpgradeMsg] = useState<boolean>(false);
    const [msgUpgrade, setMsgUpgrade] = useState<string>();
    const dispatch = useDispatch<AppDispatch>();
    const { iamotions } = useSelector((state: RootState) => state.header);
    const { t } = useTranslation();
    const isCaptionsValid =
        videoValue?.list_captions &&
        videoValue.list_captions.length > 0 &&
        videoValue.list_captions.every((item: any) => item.caption && item.caption.trim() !== "");

    useEffect(() => {
        SelectProperty().then((data) => {
            setProperties(data.r)
            setLoading(false)
        }).catch(() => {
            console.log("error")
        })
        GetCompanyProfile().then((data: any) => {
            setVideoValue((prev: any) => ({
                ...prev,
                company: {
                    logo: data?.companyLogo,
                    name: data?.companyName,
                    adress: data?.companyEmail,
                    phone: data?.companyPhone,
                    description: data?.companyDescription
                }
            }));
            setLoading(false)
        }).catch(() => {
            console.log("error")
        })
        GetAccount().then((data: any) => {
            setVideoValue((prev: any) => ({
                ...prev,
                agent: {
                    logo: data?.portrait_image,
                    photo: data?.profile_picture,
                    name: data?.name,
                    adress: data?.email,
                    phone: data?.phone_number
                }
            }));
            setLoading(false)
        }).catch(() => {
            console.log("error")
        })

    }, [])

    useEffect(() => {
        dispatch(fetchHeaderData());
    }, [dispatch]);

    const handleChangeAudio = (event: any) => {
        const selectedValue = event.target.value;
        // Update the audio source based on the selected value
        setSelectMusic(selectedValue)
        setVideoValue(
            prev => ({
                ...prev,
                music: selectedValue
            }))
    };

    const handleSelectChangeProperty = (event: any, newValue: any) => {
        if (newValue) {
            setListImages([])
            setVideoValue(prev => ({
                ...prev,
                list_captions: []
            }))
            setSelectProperty(newValue.id);
            propertieImages(newValue.id).then((data) => {
                const newImages = data.map((image: any) => ({
                    image,
                    caption: '',
                    color: '#000000',
                    motion: false,
                }));
                setListImages(newImages);
            });
        }
    }

    const handleCaptionChange = (index: number, event: any) => {
        if (!videoValue?.list_captions) return;
        const newImageData = [...videoValue?.list_captions];
        newImageData[index].caption = event.target.value;
        setVideoValue(prev => ({
            ...prev,
            list_captions: newImageData
        }));
    };

    const handleAIMotionChange = (index: any, event: any) => {
        if (!videoValue?.list_captions) return;
        const newImageData = [...videoValue?.list_captions];
        newImageData[index].motion = event.target.checked;
        setVideoValue(prev => ({
            ...prev,
            list_Captions: newImageData
        }));
    };

    const handleSelectImages = (image: any) => {
        setVideoValue((prev: any) => {
            const prevList = prev.list_captions || [];
            const isAlreadySelected = prevList.some((selectedImage: any) => selectedImage.image.id === image.image.id);

            const updatedList = isAlreadySelected
                ? prevList.filter((selectedImage: any) => selectedImage.image.id !== image.image.id)
                : [...prevList, image];

            return {
                ...prev,
                list_captions: updatedList
            };
        });
    };

    const handChangeSelectAll = () => {
        setSelectAll(!selectAll);
        const currentCaptions = videoValue?.list_captions || [];
        const updatedImages = listImages.filter(
            (image: any) =>
                !currentCaptions.some(
                    (selectedImage: any) => selectedImage.image.id === image.image.id
                )
        );
        setVideoValue((prev: any) => ({
            ...prev,
            list_captions: [...(prev.list_captions || []), ...updatedImages]
        }));
    };

    const GenerateCaptions = () => {
        const images = (videoValue?.list_captions || []).map((image: any) => (
            {
                src: image.image.src,
                id: image.image.id,
                ext: image.image.ext
            }
        ));
        const obj = {
            list_images: images,
            lang: language,
            other_desc: otherDesc,
            id: selectProperty
        }
        setIsSpinnert(true)
        GenerateCaptionsServ(obj).then((data) => {
            const updatedImages = (videoValue?.list_captions || []).map((element2: any) => {
                const matchingElement = data.data.data.find((element1: any) => element1.id === element2.image.id);
                if (matchingElement) {
                    return {
                        ...element2, // Spreading the existing properties
                        caption: matchingElement.desc, // Updating only the caption
                    };
                }
                return element2; // If no match is found, retain the original element
            });
            setLanguage("")
            setOtherDesc("")
            setVideoValue(prev => ({
                ...prev,
                list_captions: updatedImages
            }));
            setIsSpinnert(false)
        }).catch((error) => {
            setIsSpinnert(false)
            setColorSnackbar("error")
            setOpenSnackbar(true)
            setMessage("Failed to generate AI caption")
        })
    };

    const UploadImagesHandler = (listImagesValue: any[]) => {
        setListImages(null);
        setIsUpload(true)
        setVideoValue(prev => ({
            ...prev,
            list_captions: []
        }));
        setSelectProperty("");
        for (let i = 0; i < listImagesValue.length; i++) {
            const image = listImagesValue[i];
            setVideoValue(prev => ({
                ...prev,
                list_captions: [
                    ...(prev?.list_captions || []),
                    { image, caption: '', color: '#000000', motion: false, ext: image.ext }
                ]
            }));
        }
        const newImages = listImagesValue.map((image: any) => ({
            image,
            caption: '',
            color: '#000000',
            motion: false,
        }));
        setListImages(newImages);
    };

    const handleSelectChangeLanguage = (event: any) => {
        setLanguage(event.target.value);
    }

    const base64ToBlob = (base64: any, mimeType: any) => {
        const byteChars = atob(base64);
        const byteNumbers = new Array(byteChars.length);
        for (let i = 0; i < byteChars.length; i++) {
            byteNumbers[i] = byteChars.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mimeType });
    };

    const CreateVideo = async () => {
        setIsSpinner(true)
        setVideoUrl("")
        setShowMsgUpgrade("")
        ListingVideoServ(videoValue).then((response) => {
            if (response.status === 200) {
                const data = response.data;
                setIsChange(!isChange)
                // setIsDisabledApi(false)
                const blob = base64ToBlob(data, 'video/mp4');
                // Create Object URL from Blob
                const url = URL.createObjectURL(blob);
                // Set the Object URL to state
                console.log("url", url)
                setVideoUrl(url);
                setIsSpinner(false)
                setColorSnackbar("success")
                setOpenSnackbar(true)
                setMessage("Your listing video has been created successfully!")
                setTimeout(() => {
                    dispatch(fetchHeaderData());
                }, 2000)
            }
        }).catch((error: any) => {
            if (error.response.status === 401) {
                setIsUpgradeMsg(true)
                setIsSpinner(false)
                setMsgUpgrade(error.response.data.message);
            } else {
                setIsSpinner(false)
                setColorSnackbar("error")
                setOpenSnackbar(true)
                setMessage(error.response.data.message)
            }
        })
    };

    const handleCloseSnackbar = (
        event?: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    // Agent 

    const handleChangeAgent = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setVideoValue((prev: any) => ({
            ...prev,
            agent: {
                ...prev.agent,
                [name]: value
            }
        }));
    };

    const handleChangeLogoAgent = (event: any) => {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
            const base_64 = reader.result as string;
            setVideoValue((prev: any) => ({
                ...prev,
                agent: {
                    ...prev.agent,
                    logo: base_64
                }
            }));
        }
    }

    const handleChangePhotoAgent = (event: any) => {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
            const base_64 = reader.result as string;
            setVideoValue((prev: any) => ({
                ...prev,
                agent: {
                    ...prev.agent,
                    photo: base_64
                }
            }));
        }
    }

    // Company

    const handleChangeLogoCompany = (event: any) => {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
            const base_64 = reader.result as string;
            setVideoValue((prev: any) => ({
                ...prev,
                company: {
                    ...prev.company,
                    logo: base_64
                }
            }));
        }
    }

    const handleChangeCompany = (event: any) => {
        const { name, value } = event.target;
        setVideoValue((prev: any) => ({
            ...prev,
            company: {
                ...prev.company,
                [name]: value
            }
        }));
    }

    const ChangeMessageHandler = (color: string, msg: string) => {
        setColorSnackbar(color)
        setOpenSnackbar(true)
        setMessage(msg)
    }

    return loading ? (<div className="container-xxl flex-grow-1 padd-bottom-80">Loading ...</div>) : (
        <div className="container-xxl flex-grow-1 padd-bottom-80">
            <div className="row mt-4 ">
                <div className="col-md-6 d-flex align-items-center mb-4">
                    <div className="marg-right-10">
                        <a href="/properties" className="buuton-next border-trans  marg-right-16 back-EEF2FF border-9" >
                            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 14L13 7" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M6 14L13 7" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M6 14H22.3333" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M6 14H22.3333" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M6 14L13 21" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M6 14L13 21" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </a>
                    </div>
                    <div className="">
                        <h1 className="title-24 title-20-mb color-black mb-2">{t("listingVideo.createListingVideo")}</h1>
                        <p className="para-16 para-14-mb color-39393B">{t("listingVideo.createListingVideoDesc")}</p>
                    </div>

                </div>
                <div className="col-md-6 d-flex align-items-center justify-content-end mb-4">
                    <h1 className="title-20 marg-left-10 color-4F52C1">{t("listingVideo.aiMotions")}: {iamotions} </h1>
                </div>
            </div>

            {properties == null ? <></> :
                <div className="row">
                    <div className="col-md-4 mb-3 padd-10">
                        <Autocomplete
                            options={Array.isArray(properties) ? properties : []}
                            getOptionLabel={(property: any) => {
                                const bedroomsLabel = property.bedrooms > 1 ? `${property.bedrooms} bedrooms` : `${property.bedrooms} bedroom`;
                                return `${property.ref} | ${property.location} | ${bedroomsLabel}`;
                            }}
                            disablePortal
                            className="search-listing"
                            renderInput={(params) => <TextField {...params} onChange={(value) => {
                                setSelectProperty(value.target.value)
                            }}
                                InputProps={{
                                    ...params.InputProps,
                                    sx: {
                                        "&::placeholder": {
                                            color: "#000000",
                                            opacity: 1,
                                        }
                                    }
                                }}
                                placeholder={t("listingVideo.searchListing")}
                            />}
                            onChange={handleSelectChangeProperty}
                        />
                        {listImages == null ? <></> : <div className="d-flex align-items-center mt-4 mb-3">
                            <label className="color-64748B  title-onest-24 title-20-mb" htmlFor="selectTypeOpt">{t("listingVideo.selectPhotos")}</label>
                            <button className="para-onest-16 bold-600 color-4F52C1 select-all" onClick={handChangeSelectAll}>{t("enhanceAndGenerate.selectAll")}</button>
                        </div>}
                        {listImages == null ? <div></div> : <div className="image-3-grid mb-3">
                            {listImages.map((image: any, index: any) => {
                                const isChecked = (videoValue?.list_captions || []).some((selectedImage: any) => selectedImage.image.id === image.image.id);
                                return (
                                    <div
                                        key={image.image.id + "_" + index}
                                        className="select-image-container"
                                        onClick={() => handleSelectImages(image)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id={image.image.id + "_" + index}
                                            value={image.image.src}
                                            checked={isChecked}
                                            onChange={() => handleSelectImages(image)}
                                            onClick={(e) => e.stopPropagation()}
                                        />
                                        <img
                                            src={image.image.src}
                                            className="image"
                                            alt=""
                                        />
                                    </div>
                                );
                            })}
                        </div>
                        }
                        <div className="mt-4">
                            <UploadImages OnUploadImages={UploadImagesHandler} name={t("listingVideo.uploadYourPhotos")} />
                        </div>
                        <div className=" mt-4">
                            <button type="submit" className={`button-dash back-746AFF color-FFFFFF border-6 border-746AFF padd-15-40 ${isCaptionsValid && selectMusic ? "" : "disabled"}`} onClick={CreateVideo}>
                                {t("propertiesPage.create")}
                            </button>
                        </div>
                    </div>
                    <div className="col-md-8 mb-3 padd-0-20">
                        <div className="d-flex justify-content-between align-items-center">
                            <h3 className="color-64748B  title-onest-24 title-20-mb">{t("listingVideo.preview")}</h3>
                            <RecentVideos change={isChange} onchangeMessageHandler={ChangeMessageHandler} />
                        </div>


                        {(isSpinner && videoUrl == "") ?
                            <div className="card-F1F5F9 height-140 padd-20 mb-4">
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div className="spinner-border text-primary text-center" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div> : <div className="card-F1F5F9  padd-20 mb-4">
                                {videoUrl == "" ? <p className="para">{showMsgUpgrade}</p> : (
                                    <video controls style={{ width: "100%", borderRadius: "20px" }}>
                                        <source src={videoUrl} type='video/mp4' />
                                    </video>
                                )}
                            </div>}

                        <div className="row mb-4">
                            <div className="col-1">
                                <FormControl >
                                    <Select
                                        className={`custom-select marg-right-16 ${isUpload ? "disabled" : ""}`}
                                        displayEmpty
                                        inputProps={{ 'aria-label': 'Caption Language' }}
                                        value={language || ""}
                                        onChange={handleSelectChangeLanguage}
                                        sx={{
                                            background: "#F1F5F9 !important",
                                            borderRadius: "6px !important",
                                            fontFamily: 'Plus Jakarta Sans',
                                            fontStyle: "normal",
                                            fontWeight: "600 !important",
                                            fontSize: "14px !important",
                                            lineHeight: "18px",
                                            color: "#334155 !important"
                                        }}
                                        renderValue={(selected) =>
                                            selected ? selected.charAt(0).toUpperCase() + selected.slice(1) : `${t("listingVideo.captionLanguage")}`
                                        }>
                                        <MenuItem value="" disabled>
                                            {t("propertiesPage.select")}
                                        </MenuItem>
                                        <MenuItem value={"arabic"}>{t("propertyDetails.Arabic")}</MenuItem>
                                        <MenuItem value={"english"}>{t("propertyDetails.English")}</MenuItem>
                                    </Select>
                                </FormControl>

                                <button type="button" className={`button-reset back-6366F1 color-FFFFFF  border-6366F1 height-44 padd-15 ${(videoValue?.list_captions || []).length !== 0 && language ? "" : "disabled"}`} onClick={GenerateCaptions} >
                                    {t("listingVideo.generateAICaption")} {isSpinnert && <div className="spinner-border text-white  size-20 marg-left-5" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>}
                                </button>
                            </div>
                            {/* <div className="col-1 d-flex  justify-content-end">
                                <ShareVideo videoUrl={videoUrl} isDisabled={false} />
                                <DownloadVideo videoUrl={videoUrl} isDisabled={false} />
                            </div> */}
                        </div>

                        <div className=" border-trans selected-img-videos  padd-20 ">
                            {(videoValue?.list_captions || []).length !== 0 && (videoValue?.list_captions || []).map((image: any, index: any) => (
                                <div className="captions back-FFFFFF padd-20 border-trans border-14 mb-3" key={image.image.id}>
                                    <div>
                                        <img src={image.image.src} className="image" alt="image property" />
                                    </div>
                                    <div className="mb-2">
                                        <div className="input-group mb-2">
                                            <input
                                                type="text"
                                                dir="auto"
                                                className="form-control border-#D9D9D9  border-10 height-46"
                                                placeholder="Caption"
                                                value={image.caption}
                                                onChange={(e) => handleCaptionChange(index, e)}
                                            />
                                        </div>
                                        <div className="form-check" style={{ pointerEvents: 'none' }}>
                                            <input
                                                className="form-check-input border-6366F1"
                                                type="checkbox"
                                                id={`motion-${index}`}
                                                onChange={(e) => handleAIMotionChange(index, e)}
                                                checked={image.motion}
                                                disabled={
                                                    (videoValue?.list_captions || []).filter((img: any) => img.motion).length === (videoValue?.list_captions || []).length - 2 &&
                                                    !image.motion
                                                }
                                                style={{ pointerEvents: 'auto' }}
                                            />
                                            <span className="form-check-label font-12 color-6366F1">
                                                {t("listingVideo.aiMotion")}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            <div className="back-FFFFFF padd-20 border-trans border-14 mb-3">
                                <div className="title-18 mb-4"> {t("listingVideo.agentProfile")}</div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div>
                                            <label htmlFor="Portrait Image" className="form-label-1 mb-2">{t("listingVideo.profilePicture")}</label>
                                            <div className='profile-upload mb-3'>
                                                <div><img src={videoValue?.agent?.logo == "" ? "/assets/images/LogoUser.jfif" : videoValue?.agent?.logo} style={{ display: "inline" }} />
                                                    Logo.PNG</div>
                                                <label htmlFor="Portrait1">
                                                    <input type="file" id="Portrait1" style={{ display: 'none' }} accept=" image/*" onChange={handleChangeLogoAgent} />
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M5.53999 19.5196C4.92999 19.5196 4.35999 19.3096 3.94999 18.9196C3.42999 18.4296 3.17999 17.6896 3.26999 16.8896L3.63999 13.6496C3.70999 13.0396 4.07999 12.2296 4.50999 11.7896L12.72 3.09956C14.77 0.929561 16.91 0.869561 19.08 2.91956C21.25 4.96956 21.31 7.10956 19.26 9.27956L11.05 17.9696C10.63 18.4196 9.84999 18.8396 9.23999 18.9396L6.01999 19.4896C5.84999 19.4996 5.69999 19.5196 5.53999 19.5196ZM15.93 2.90956C15.16 2.90956 14.49 3.38956 13.81 4.10956L5.59999 12.8096C5.39999 13.0196 5.16999 13.5196 5.12999 13.8096L4.75999 17.0496C4.71999 17.3796 4.79999 17.6496 4.97999 17.8196C5.15999 17.9896 5.42999 18.0496 5.75999 17.9996L8.97999 17.4496C9.26999 17.3996 9.74999 17.1396 9.94999 16.9296L18.16 8.23956C19.4 6.91956 19.85 5.69956 18.04 3.99956C17.24 3.22956 16.55 2.90956 15.93 2.90956Z" fill="#282828" />
                                                        <path d="M17.3404 10.9498C17.3204 10.9498 17.2904 10.9498 17.2704 10.9498C14.1504 10.6398 11.6404 8.26985 11.1604 5.16985C11.1004 4.75985 11.3804 4.37985 11.7904 4.30985C12.2004 4.24985 12.5804 4.52985 12.6504 4.93985C13.0304 7.35985 14.9904 9.21985 17.4304 9.45985C17.8404 9.49985 18.1404 9.86985 18.1004 10.2798C18.0504 10.6598 17.7204 10.9498 17.3404 10.9498Z" fill="#282828" />
                                                        <path d="M21 22.75H3C2.59 22.75 2.25 22.41 2.25 22C2.25 21.59 2.59 21.25 3 21.25H21C21.41 21.25 21.75 21.59 21.75 22C21.75 22.41 21.41 22.75 21 22.75Z" fill="#282828" />
                                                    </svg>
                                                </label>
                                            </div>
                                        </div>
                                        <label htmlFor="Name" className="form-label-1 mb-2 ">{t("home.name")}</label>
                                        <input type="text" className="form-control border-#D9D9D9  border-10 mb-3 height-46" placeholder={t("listingVideo.yourName")} value={videoValue?.agent?.name ? videoValue?.agent?.name : " "} name="name" onChange={handleChangeAgent} />

                                        <label htmlFor="Email Address" className="form-label-1 mb-2"> {t("propertyDetails.emailAddress")}</label>
                                        <input type="email" id="Email Address" className="form-control border-#D9D9D9  border-10 mb-3 height-46" placeholder={t("propertyDetails.emailAddress")} value={videoValue?.agent?.adress ? videoValue?.agent?.adress : ""} name="adress" onChange={handleChangeAgent} />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="Standing Potrait" className="form-label-1 mb-2">{t("listingVideo.standingPotrait")}</label>
                                        <div>  <div className='profile-upload mb-3'>
                                            <div>
                                                <img src={videoValue?.agent?.photo == "" ? "/assets/images/LogoUser.jfif" : videoValue?.agent?.photo} style={{ display: "inline" }} />
                                                Photo.PNG</div>
                                            <label htmlFor="Portrait2">
                                                <input type="file" id="Portrait2" style={{ display: 'none' }} accept=" image/*" onChange={handleChangePhotoAgent} />
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M5.53999 19.5196C4.92999 19.5196 4.35999 19.3096 3.94999 18.9196C3.42999 18.4296 3.17999 17.6896 3.26999 16.8896L3.63999 13.6496C3.70999 13.0396 4.07999 12.2296 4.50999 11.7896L12.72 3.09956C14.77 0.929561 16.91 0.869561 19.08 2.91956C21.25 4.96956 21.31 7.10956 19.26 9.27956L11.05 17.9696C10.63 18.4196 9.84999 18.8396 9.23999 18.9396L6.01999 19.4896C5.84999 19.4996 5.69999 19.5196 5.53999 19.5196ZM15.93 2.90956C15.16 2.90956 14.49 3.38956 13.81 4.10956L5.59999 12.8096C5.39999 13.0196 5.16999 13.5196 5.12999 13.8096L4.75999 17.0496C4.71999 17.3796 4.79999 17.6496 4.97999 17.8196C5.15999 17.9896 5.42999 18.0496 5.75999 17.9996L8.97999 17.4496C9.26999 17.3996 9.74999 17.1396 9.94999 16.9296L18.16 8.23956C19.4 6.91956 19.85 5.69956 18.04 3.99956C17.24 3.22956 16.55 2.90956 15.93 2.90956Z" fill="#282828" />
                                                    <path d="M17.3404 10.9498C17.3204 10.9498 17.2904 10.9498 17.2704 10.9498C14.1504 10.6398 11.6404 8.26985 11.1604 5.16985C11.1004 4.75985 11.3804 4.37985 11.7904 4.30985C12.2004 4.24985 12.5804 4.52985 12.6504 4.93985C13.0304 7.35985 14.9904 9.21985 17.4304 9.45985C17.8404 9.49985 18.1404 9.86985 18.1004 10.2798C18.0504 10.6598 17.7204 10.9498 17.3404 10.9498Z" fill="#282828" />
                                                    <path d="M21 22.75H3C2.59 22.75 2.25 22.41 2.25 22C2.25 21.59 2.59 21.25 3 21.25H21C21.41 21.25 21.75 21.59 21.75 22C21.75 22.41 21.41 22.75 21 22.75Z" fill="#282828" />
                                                </svg>
                                            </label>
                                        </div>
                                        </div>
                                        <label htmlFor="Phone Number" className="form-label-1 mb-2">{t("propertyDetails.phoneNumber")}</label>
                                        <input type="text" className="form-control border-#D9D9D9  border-10 mb-3 height-46" placeholder={t("propertyDetails.phoneNumber")} value={videoValue?.agent?.phone ? videoValue?.agent?.phone : ""} name="phone" onChange={handleChangeAgent} />

                                        <label htmlFor="Description" className="form-label-1 mb-2">{t("generateDescTitle.description")}</label>
                                        <input type="text" className="form-control border-#D9D9D9  border-10 mb-3 height-46" placeholder={t("generateDescTitle.description")} style={{ height: "40px" }} value={videoValue?.agent?.description ? videoValue?.agent?.description : ""} name="description" onChange={handleChangeAgent} />

                                    </div>
                                </div>
                            </div>
                            <div className="back-FFFFFF padd-20 border-trans border-14 mb-3">
                                <div className="title-18 mb-4">{t("report.companyProfile")} </div>
                                <div className="row ">
                                    <div className="col-md-6">

                                        <label htmlFor="Name" className="form-label-1 mb-2">{t("home.name")}</label>
                                        <input type="text" className="form-control border-#D9D9D9  border-10 mb-3 height-46" placeholder={t("listingVideo.yourName")} value={videoValue?.company?.name ? videoValue?.company?.name : " "} name="name" onChange={handleChangeCompany} />

                                        <label htmlFor="Email Address" className="form-label-1 mb-2 ">{t("propertyDetails.emailAddress")}</label>
                                        <input type="email" id="Email Address" className="form-control border-#D9D9D9  border-10 mb-3 height-46" placeholder={t("propertyDetails.emailAddress")} value={videoValue?.company?.adress ? videoValue?.company?.adress : ""} name="adress" onChange={handleChangeCompany} />
                                        <div>
                                            <label htmlFor="Portrait Image" className="form-label-1 mb-2">{t("settings.companyLogo")}</label>
                                            <div className='profile-upload mb-3'>
                                                <div><img src={videoValue?.company?.logo == "" ? "/assets/images/LogoUser.jfif" : videoValue?.company?.logo} style={{ display: "inline" }} />
                                                    Logo.PNG</div>
                                                <label htmlFor="Portrait1-9">
                                                    <input type="file" id="Portrait1-9" style={{ display: 'none' }} accept=" image/*" onChange={handleChangeLogoCompany} />
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M5.53999 19.5196C4.92999 19.5196 4.35999 19.3096 3.94999 18.9196C3.42999 18.4296 3.17999 17.6896 3.26999 16.8896L3.63999 13.6496C3.70999 13.0396 4.07999 12.2296 4.50999 11.7896L12.72 3.09956C14.77 0.929561 16.91 0.869561 19.08 2.91956C21.25 4.96956 21.31 7.10956 19.26 9.27956L11.05 17.9696C10.63 18.4196 9.84999 18.8396 9.23999 18.9396L6.01999 19.4896C5.84999 19.4996 5.69999 19.5196 5.53999 19.5196ZM15.93 2.90956C15.16 2.90956 14.49 3.38956 13.81 4.10956L5.59999 12.8096C5.39999 13.0196 5.16999 13.5196 5.12999 13.8096L4.75999 17.0496C4.71999 17.3796 4.79999 17.6496 4.97999 17.8196C5.15999 17.9896 5.42999 18.0496 5.75999 17.9996L8.97999 17.4496C9.26999 17.3996 9.74999 17.1396 9.94999 16.9296L18.16 8.23956C19.4 6.91956 19.85 5.69956 18.04 3.99956C17.24 3.22956 16.55 2.90956 15.93 2.90956Z" fill="#282828" />
                                                        <path d="M17.3404 10.9498C17.3204 10.9498 17.2904 10.9498 17.2704 10.9498C14.1504 10.6398 11.6404 8.26985 11.1604 5.16985C11.1004 4.75985 11.3804 4.37985 11.7904 4.30985C12.2004 4.24985 12.5804 4.52985 12.6504 4.93985C13.0304 7.35985 14.9904 9.21985 17.4304 9.45985C17.8404 9.49985 18.1404 9.86985 18.1004 10.2798C18.0504 10.6598 17.7204 10.9498 17.3404 10.9498Z" fill="#282828" />
                                                        <path d="M21 22.75H3C2.59 22.75 2.25 22.41 2.25 22C2.25 21.59 2.59 21.25 3 21.25H21C21.41 21.25 21.75 21.59 21.75 22C21.75 22.41 21.41 22.75 21 22.75Z" fill="#282828" />
                                                    </svg>
                                                </label>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="Phone Number" className="form-label-1 mb-2">{t("propertyDetails.phoneNumber")}</label>
                                        <input type="text" className="form-control border-#D9D9D9  border-10 mb-3 height-46" placeholder={t("propertyDetails.phoneNumber")} value={videoValue?.company?.phone ? videoValue?.company?.phone : ""} name="phone" onChange={handleChangeCompany} />

                                        <label htmlFor="Description" className="form-label-1 mb-2">{t("generateDescTitle.description")}</label>
                                        <input type="text" className="form-control border-#D9D9D9  border-10 mb-3 height-46" placeholder={t("generateDescTitle.description")} style={{ height: "40px" }} value={videoValue?.company?.description ? videoValue?.company?.description : ""} name="description" onChange={handleChangeCompany} />

                                    </div>
                                </div>
                            </div>

                            <div className="back-FFFFFF padd-20 border-trans border-14">
                                <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("listingVideo.selectMusic")}</label>
                                <FormControl fullWidth>
                                    <Select
                                        className="custom-select"
                                        displayEmpty
                                        inputProps={{ 'aria-label': 'Select' }}
                                        value={selectMusic || ""}
                                        onChange={handleChangeAudio}
                                        sx={{
                                            border: "1px solid #D9D9D9 !important",
                                            borderRadius: "10px !important",
                                            background: "#FFFFFF !important",
                                            color: "rgba(0, 0, 0, 0.6) !important"
                                        }}>
                                        <MenuItem value="" disabled>{t("propertiesPage.select")}</MenuItem>
                                        {
                                            listAudios.map((music: any, index: number) => {
                                                return <MenuItem value={music.url} key={index}>{music.name}</MenuItem>
                                            })
                                        }
                                    </Select>
                                </FormControl>
                                {videoValue?.music && (
                                    <div className="mt-3">
                                        <AudioPlayer
                                            autoPlay
                                            src={videoValue?.music}
                                            loop={false}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>
                </div>}

            <Snackbar open={openSnackbar} onClose={handleCloseSnackbar} autoHideDuration={5000}>
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={colorSnackbar || "info"}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {message}
                </Alert>
            </Snackbar>

            <Dialog
                open={isUpgradeMsg}
                onClose={() => setIsUpgradeMsg(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title" className="title-20 color-000000 d-flex align-items-center gap-2">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="#746AFF"
                        viewBox="0 0 24 24"
                    >
                        <path d="M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm1 17h-2v-2h2zm0-4h-2V7h2z" />
                    </svg>
                    {t("listingCreation.upgradeRequired")}
                </DialogTitle>

                <DialogContent>
                    <p className="title-18 bold-400 line-height-30 color-000000" style={{ marginBottom: 0 }}>
                        {msgUpgrade}
                    </p>
                </DialogContent>
                <DialogActions>
                    <button
                        type="button"
                        className="button-dash padd-15-30 border-trans border-746AFF color-746AFF"
                        onClick={() => setIsUpgradeMsg(false)}
                    >
                        {t("propertiesPage.close")}
                    </button>
                </DialogActions>
            </Dialog>

        </div>
    )
}
export default ListingVideo;